/**
 * Un 401 signifie-t-il que **notre jeton** est refusé ?
 *
 * Pas toujours : encore faut-il que la requête en ait porté un. Une requête
 * partie sans `Authorization` reçoit elle aussi un 401, et celui-là ne dit
 * strictement rien de la session stockée.
 *
 * Côté app, ignorer la distinction déconnectait l'utilisateur au démarrage à
 * froid : la session y est lue de façon **asynchrone**, donc une requête peut
 * partir avant. Ici la session vient de `localStorage`, lu de façon
 * synchrone — la course n'existe pas au montage.
 *
 * On garde quand même le garde-fou : dès qu'une requête est émise
 * volontairement sans jeton (page de connexion, endpoint public), son 401 ne
 * doit pas effacer une session valide.
 */
export function isTokenRejection(
  status: number,
  authorizationHeader: string | null,
): boolean {
  return status === 401 && Boolean(authorizationHeader);
}
